import React, { useCallback, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import useStylesCommon from '../common/AdditionalDetailsCommonStyles';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import { useTranslation } from 'react-i18next';
import { PatientDiagnosticOrderHeadersDto } from '../../../../services/diagnostic/orderHeadersProvider';
import { GetApp } from '@material-ui/icons';
import useReferralsForMedicalTestsContext, { ReferralsForMedicalTestsContext } from '../../../../hooks/referrals/patientMedicalTests/useReferralsForMedicalTestsContext';
import referralsProvider from '../../../../services/referralsProvider';
import filesDownloadProvider from '../../../../services/filesDownloadProvider';
import axios from 'axios';
import Loading from '../../../common/Loading/Loading';
import { AlertContext } from '../../../../contexts/AlertContext';

type PatientDiagnosticOrdersListProps = {
    diagnosticOrders?: PatientDiagnosticOrderHeadersDto[];
};

const useStyles = makeStyles((theme) => ({
	orderItem: {
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    orderDetails: {
        display: 'flex',
        flexDirection: 'column',

    }
}));

const PatientDiagnosticOrdersList = ({ diagnosticOrders }: PatientDiagnosticOrdersListProps) => {
    const classesCommon = useStylesCommon();
	const classes = useStyles();
    const {t} = useTranslation(i18nNamespaces.APPOINTMENT_DETAILS);
    const {t: tCommon} = useTranslation(i18nNamespaces.COMMON);
    const {t: tErrors} = useTranslation(i18nNamespaces.ERRORS);
    const [loading, setLoading] = React.useState(false);
    const openAlert = useContext(AlertContext);
    
    const handleDownloadPdf = async (id:string) =>{
        try{
            setLoading(true);
            const url = (await referralsProvider.getDiagnosticOrderReferralPdfUrl(id)).data;
            if(url !== null){
                filesDownloadProvider.downloadFileFromUrl(
                    url,
                    tCommon('referral')+".pdf"
                );
            }
        }
        catch(error){
            if (axios.isAxiosError(error) &&
                error.response.status === 404)
                openAlert({
                    severity: 'error',
                    message: tCommon('fileNotGenerated'),
                });
        
            else
                openAlert({
                    severity: 'error',
                    message: tErrors('downloadReferralError'),
                });
            
        } finally {
            setLoading(false);
        }
    }


	return (
        <Box style={{marginBottom: 20, marginTop: 20}}>
            <Loading loading={loading} withBackdrop />
            <h4 className={`${classesCommon.detailsHeader}`}>
                {t('diagnosticOrders')}
            </h4>
            {diagnosticOrders && diagnosticOrders.length > 0 ? (
                diagnosticOrders.map(order => (
                    <Box key={order.id} className={classes.orderItem}>
                        <Box className={classes.orderDetails}>
                            <Box>
                                {t(order.type.toLowerCase())}, {t('patient')}: {order.patientName} {order.patientSurname}
                            </Box>
                        </Box>
                        <Box>
                            {
                                order.availableInPdfForm && (
                                    <IconButton
                                        size={'small'}
                                        style={{marginLeft: 10}}
                                        onClick={() => handleDownloadPdf(order.id)}
                                    >
                                        <GetApp fontSize={'small'} color={'secondary'}/>
                                    </IconButton>
                                )
                            }
                        </Box>
                    </Box>
                ))
            ) : (
                <p>{t('noDiagnosticOrders')}</p>
            )}
        </Box>
	);
};

export default PatientDiagnosticOrdersList;
